var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInterlinked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "97FB65AB-8972-42BC-9D44-F332B1290CED") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Entity-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TaxPro-Entity-Details-IntLink-2.1",
    transform: "translate(-739.500000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Interlinked",
    transform: "translate(751.500000, 363.000000) rotate(-90.000000) translate(-751.500000, -363.000000) translate(739.500000, 351.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 8.32759823e-15 24 8.32759823e-15 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8214286,16 L16.8214286,13.7411765 C16.8214286,13.2183007 16.6304563,12.7738562 16.2485119,12.4078431 C15.8665675,12.0418301 15.4027778,11.8588235 14.8571429,11.8588235 L9.25892857,11.8588235 L11.2723214,13.7882353 L10.4375,14.5882353 L7,11.2941176 L10.4375,8 L11.2723214,8.8 L9.25892857,10.7294118 L14.8571429,10.7294118 C15.7301587,10.7294118 16.4722222,11.0222222 17.0833333,11.6078431 C17.6944444,12.1934641 18,12.9045752 18,13.7411765 L18,16 L16.8214286,16 Z",
    id: "Interlinked",
    fill: "#677283",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInterlinked);
export default __webpack_public_path__ + "static/media/Icon_Interlinked.c078a88e.svg";
export { ForwardRef as ReactComponent };